module.exports = __webpack_public_path__ + "static/media/FruitDeChanceLogo.f1499811.png";